export const TRANSLATION_PLAYER_BONUS_CREATE_FILE = Symbol('players-bonuse.create-file');
export const PLAYERS_BONUS_CREATE_FILE_ROUTE_NAME = Symbol('admin.players.bonuses.create.file');

export const BONUS_FILE_CREATE_MUTATION_KEY = Symbol('bonus-file.create');
export const BONUS_FILE_CREATE_API_URL = 'admin/bonuses/create_with_file';
